import { UtilityService } from '../utility.service';
import { GetConsentsService } from '../consents-services/get-consents.service';

/**
 * This class provide window.usercentrics functions.
 */
export class AnchorTagService {
    constructor(public utilityService: UtilityService) { }

    initHandle(target, event) {
        if ((target.localName && target.localName.toLowerCase() === 'a') ||
            (target.nodeName && target.nodeName.toLowerCase() === 'a')
        ) {
            const href = target.getAttribute('href');
            if (href && href.indexOf('#uc-') > -1) {
                event.preventDefault();
                event.stopPropagation();
                this.anchorClickEvent(href, target);
            }
        } else if (target.parentNode) {
            this.initHandle(target.parentNode, event);
        }
    }

    anchorClickEvent(targetHref: string, target: HTMLElement) {
        switch (targetHref) {
            case '#usercentrics-button':
            case '#uc-button-toggle':
                this.utilityService.settingsService.privacyButtonIsVisible = !this.utilityService.settingsService.elementsVisibility.primaryButton;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-button-show':
                this.utilityService.settingsService.privacyButtonIsVisible = true;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-button-hide':
                this.utilityService.settingsService.privacyButtonIsVisible = false;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-chip-toggle':
                this.utilityService.settingsService.chipIsVisible = !this
                    .utilityService.settingsService.elementsVisibility.chipButton;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-chip-show':
                this.utilityService.settingsService.chipIsVisible = true;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-chip-hide':
                this.utilityService.settingsService.chipIsVisible = false;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-banner-toggle':
                this.utilityService.settingsService.bannerIsVisible = !this
                    .utilityService.settingsService.elementsVisibility.bannerVisible;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-banner-show':
                this.utilityService.settingsService.bannerIsVisible = true;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-banner-hide':
                this.utilityService.settingsService.bannerIsVisible = false;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#usercentrics-modal':
            case '#uc-central-modal-show':
                this.utilityService.UserCentricViewController.privacyCenterModal.updateCloseIconVisibility(
                    true
                );
                this.utilityService.UserCentricViewController.privacyCenterModal.openModal()
                break;
            case '#uc-central-modal-closable-show':
                this.utilityService.UserCentricViewController.privacyCenterModal.updateCloseIconVisibility(
                    false
                );
                this.utilityService.UserCentricViewController.privacyCenterModal.openModal();
                break;
            case '#usercentrics-info':
            case '#uc-info-modal-show':
                this.utilityService.UserCentricViewController.consentsInfoModal.visible = true;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-corner-modal-show':
                this.utilityService.UserCentricViewController.privacyCornerModal.openModal();
                break;
            case '#uc-corner-modal-hide':
                this.utilityService.UserCentricViewController.privacyCornerModal.closeModal();
                break;
            case '#uc-deny-all-consents':
                const action = 'onDenyAllAnchorClick';
                const updatedBy = 'explicit';
                this.utilityService.saveConsentsService.denyAllConsentsExceptEssential(
                    action,
                    updatedBy
                );
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-accept-all-consents':
                if (!this.utilityService.isConsentChangeAllow) {
                    break;
                }
                const action1 = 'onAcceptAllAnchorClick';
                const updatedBy1 = 'explicit';
                this.utilityService.saveConsentsService.acceptAllConsents(action1, updatedBy1);
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-accept-all-consents-and-close-initial-view':
                if (!this.utilityService.isConsentChangeAllow) {
                    break;
                }
                const action2 = 'onAcceptAllAnchorClick';
                const updatedBy2 = 'explicit';
                this.utilityService.settingsService.saveFirstUserInteraction();
                this.utilityService.saveConsentsService.acceptAllConsents(action2, updatedBy2);
                this.utilityService.settingsService.bannerIsVisible = false;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-deny-all-consents-and-close-initial-view':
                if (!this.utilityService.isConsentChangeAllow) {
                    break;
                }
                this.utilityService.settingsService.saveFirstUserInteraction();
                const action3 = 'onDenyAllAnchorClick';
                const updatedBy3 = 'explicit';
                this.utilityService.saveConsentsService.denyAllConsentsExceptEssential(
                    action3,
                    updatedBy3
                );
                this.utilityService.settingsService.bannerIsVisible = false;
                this.utilityService.UserCentricViewController.updateView();
                break;
            case '#uc-optin-read-more':
                // Try to get the id of the element to be displayed
                const showElementId = target.dataset.id;
                if (typeof showElementId === 'undefined') {
                    return;
                }
                // Get the element to show and return if not found
                const showElement = <HTMLCollectionOf<HTMLElement>>document.getElementsByClassName(showElementId);
                if (showElement.length === 0) {
                    return;
                }
                // Hide the link
                target.style.display = 'none';
                // Show the elmement(s)
                for (let i = 0; i < showElement.length; i++) {
                    showElement[i].style.display = 'inline';
                }
                break;

            default:
                break;
        }
        if (targetHref.indexOf('#uc-info-modal-show-cat-') !== -1) {
            let cat = targetHref.substring(targetHref.indexOf('#uc-info-modal-show-cat-') + 24);
            cat = cat.split('%20').join(' ');
            this.utilityService.developmentLog(`open info modal for ${JSON.stringify(cat)}`);
            if (cat) {
                this.utilityService.UserCentricViewController.openConsentInfoModal(cat);
            } else {
                this.utilityService.UserCentricViewController.openConsentInfoModal();
            }
        } else if (targetHref.indexOf('#uc-info-modal-show-') !== -1) {
            let proc = targetHref.substring(targetHref.indexOf('#uc-info-modal-show-') + 20);
            proc = proc.split('%20').join(' ');
            const consent = GetConsentsService.getConsentByProcessor(proc);
            this.utilityService.developmentLog(`open info modal for ${JSON.stringify(consent)}`);
            if (consent && consent.templateId) {
                this.utilityService.UserCentricViewController.openConsentInfoModal(consent.templateId);
            } else {
                this.utilityService.UserCentricViewController.openConsentInfoModal();
            }
        }
    }
}
